import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="terms-page">
      <div className="terms-hero">
        <div className="container">
          <h1>תקנון אתר</h1>
        </div>
      </div>

      <section className="terms-content">
        <div className="container">
          <div className="terms-card">
            <h2>מבוא</h2>
            <p>
              ברוכים הבאים לאתר של אוטוקרוס. השימוש באתר כפוף לתנאים המפורטים להלן. השימוש באתר, לרבות הצפייה בתכנים, הגלישה בו או השימוש בשירותים המוצעים, מהווה את הסכמתך לתנאי השימוש. אם אינך מסכים לאחד מהתנאים, עליך להימנע מלהשתמש באתר.
            </p>

            <h2>קניין רוחני</h2>
            <p>
              כל התוכן המופיע באתר, לרבות אך לא רק טקסטים, תמונות, גרפיקה, סימנים מסחריים, לוגו, קוד תוכנה וכל חומר אחר, הוא רכוש אוטוקרוס או של צדדים שלישיים, והם מוגנים בזכויות יוצרים, סימנים מסחריים וזכויות קניין רוחני אחרות. אין להעתיק, לשכפל, להפיץ, לשדר, להציג, לבצע, לפרסם או למכור כל חלק מהתוכן ללא הסכמתנו המפורשת.
            </p>

            <h2>שימוש באתר</h2>
            <p>
              האתר מיועד להצגת מידע, קטלוג רכבים, מחירים ודגמים. השימוש באתר מבוצע אך ורק למטרות אינפורמטיביות ולצרכים פרטיים של המשתמש. האתר לא משמש לפעולות מכירה ישירה, וכל רכישת רכב תתבצע בהסכם נפרד בין הלקוח לבין אוטוקרוס או הספקים הרלוונטיים. כל המידע המופיע באתר, לרבות המחירים, הקטגוריות והדגמים, נמסר לצורכי הצגה בלבד, ויכולים להשתנות מעת לעת.
            </p>

            <h2>הבהרה לגבי המחירים</h2>
            <p>
              המחירים המוצגים באתר הם מחירים משוערים ומעודכנים נכון למועד הצגת המידע. עם זאת, המחירים יכולים להשתנות בכל עת בהתאם לשיקול דעתה של אוטוקרוס. כל שינוי במחיר או במפרט הרכב ייכנס לתוקף לאחר פרסום המידע באתר. אוטוקרוס אינה מתחייבת כי המחירים או פרטי הרכבים יישארו כפי שהם לאורך זמן.
            </p>

            <h2>הגבלת אחריות</h2>
            <p>
              המידע המופיע באתר נמסר "כפי שהוא" ואינו מהווה הצעה לרכישה. אוטוקרוס לא תישא באחריות לכל נזק ישיר, עקיף, תוצאתי או נלווה, הנגרם כתוצאה משימוש או הסתמכות על המידע המופיע באתר. אוטוקרוס לא אחראית למידע שגוי, לא עדכני או חסר.
            </p>

            <h2>פרטיות</h2>
            <p>
              אנו מכבדים את פרטיותכם. השימוש באתר כפוף למדיניות הפרטיות שלנו, המפורטת בנפרד. אנו אוספים מידע אישי שנמסר לנו על ידי המשתמשים ומבצעים שימוש במידע זה אך ורק בהתאם למדיניות הפרטיות. פרטיך לא יועברו לצדדים שלישיים, למעט במקרים שבהם נדרשת העברה לפי הוראות חוק או בקשה משפטית.
            </p>

            <h2>שימוש במידע אישי</h2>
            <p>
              כל משתמש אשר משאיר פרטים אישיים באתר, לרבות אך לא רק שם, כתובת דוא"ל, מספר טלפון, מסכים ומאשר כי אוטוקרוס רשאית לשמור את המידע במאגרי המידע שלה וליצור עמו קשר בעת הצורך, כולל לצורך הצגת הצעות, עדכונים, פרסומים ומידע שיווקי אחר הקשור לפעילות החברה. המידע שיימסר יישמר בהתאם למדיניות הפרטיות של החברה, ויועבר לצדדים שלישיים רק במקרה של הצורך לצורך השירותים המוצעים באתר או על פי דרישה חוקית.
            </p>

            <h2>קישורים לאתרים חיצוניים</h2>
            <p>
              האתר עשוי להכיל קישורים לאתרים חיצוניים. קישורים אלו ניתנים לנוחות בלבד. אוטוקרוס אינה אחראית לאתרים אלו ולתוכן המופיע בהם, ואינה נושאת באחריות לשירותים או למוצרים המוצעים בהם.
            </p>

            <h2>זכויות שינוי והתאמה</h2>
            <p>
              אוטוקרוס שומרת לעצמה את הזכות לשנות, לעדכן או להפסיק את פעילות האתר בכל עת, מבלי להודיע מראש למשתמשים. השינויים בתנאים אלה ייכנסו לתוקף עם פרסומם באתר, ותנאים אלו יוחלפו בתנאים חדשים. אנו ממליצים לעיין בתנאים הללו מדי פעם כדי להיות מעודכנים.
            </p>

            <h2>תנאים עבור שינויים במחירים ובמלאי</h2>
            <p>
              המחירים המפורסמים באתר הם בגדר הערכה בלבד. אוטוקרוס רשאית לשנות את המחירים, לשנות את המלאי או לעדכן פרטים טכניים של הרכבים המוצגים מבלי להודיע מראש. כל שינוי יפורסם באתר, והמשתמש מאשר כי הוא מבין שהמחירים או הזמינות של רכבים עשויים להשתנות בין הזמן שבו הצפייה במידע לבין הזמן שבו מתבצע הרכישה.
            </p>

            <h2>סמכות שיפוט</h2>
            <p>
              הדין החל על תקנון זה והשימוש באתר הינו הדין של מדינת ישראל בלבד. כל סכסוך הנוגע לשימוש באתר, יידון בפני בית המשפט המוסמך במחוז תל אביב-יפו, אשר יהיה בעל הסמכות השיפוטית הבלעדית.
            </p>

            {/* Add more sections as needed, e.g., User Conduct, Account Terms (if applicable), etc. */}

          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
